const scoped = ['business/transactions', 'business/customers', 'business/links',
  'business/checkouts', 'business/stransactions', 'business/products',
  'bulk', 'fundraising', 'wallet', 'payplan', 'reporting', 'reports'];

export function apiBoundary(client, config, backendHost) {
  const requested = config.url ?? '';
  if (/^[a-z][a-z0-9+.-]*:/i.test(requested) && !/^https?:\/\//i.test(requested)) throw new Error('Invalid API scheme');
  const backend = new URL(backendHost);
  if (!['https:', 'http:'].includes(backend.protocol) || backend.username || backend.password ||
      backend.search || backend.hash) throw new Error('Invalid backend URL');
  const root = backend.pathname.replace(/\/$/, '');
  const raw = client.getUri({...config, params: undefined});
  // Reject spellings that browsers/proxies can interpret as a different route.
  const path = raw.split(/[?#]/, 1)[0];
  if (/[\\\s]/.test(raw) || /%(?:2e|2f|5c|25|00)/i.test(path) ||
      /(?:^|\/)\.{1,2}(?:\/|$)/.test(path) || /^\/\//.test(raw)) {
    throw new Error('Ambiguous API URL');
  }
  const target = new URL(raw);
  const api = root + '/api/v1.1/';
  const auth = root + '/api/auth/browser/v1/';
  const protectedUpload = root + '/upload/';
  const isProtectedUpload = target.pathname.startsWith(protectedUpload) &&
    /^\d+\/(?:preview\/)?$/.test(target.pathname.slice(protectedUpload.length));
  if (target.origin !== backend.origin || target.username || target.password || target.hash ||
      (!isProtectedUpload && ![api, auth].some(prefix => target.pathname.startsWith(prefix)))) {
    throw new Error('Destination outside the MeSomb API');
  }
  const endpoint = target.pathname.startsWith(api) ? target.pathname.slice(api.length) : '';
  const applicationScoped = scoped.some(prefix => endpoint === prefix || endpoint.startsWith(prefix + '/'));
  return {
    url: target.href,
    applicationScoped,
    // Keyed application endpoints already encode their scope in the path; cancel stale reads
    // without changing their existing server-side filtering semantics.
    applicationBound: applicationScoped || /^(?:apiaccess|webhook|business\/automations)(?:\/|$)/.test(endpoint) ||
      /^business\/applications\/(?!limit(?:\/|$)|upsell(?:\/|$)|invite(?:\/|$))[^/]+\//.test(endpoint),
  };
}
